import { render, staticRenderFns } from "./scoreComponentEntry.vue?vue&type=template&id=724130c1&scoped=true"
import script from "./scoreComponentEntry.vue?vue&type=script&lang=js"
export * from "./scoreComponentEntry.vue?vue&type=script&lang=js"
import style0 from "./scoreComponentEntry.vue?vue&type=style&index=0&id=724130c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724130c1",
  null
  
)

export default component.exports